import React, { Component } from 'react';
import { Link } from 'react-router-dom';



class Menu extends Component {


    render() {
        return (
            <>
                <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                    <ul class="navigation clearfix">
                        {/* <li class="dropdown"><Link to={'/home-english'}>Home</Link>
                            <ul>
                                <li><Link to={'/#'}>Home page 01</Link></li>
                                <li><Link to={'/index-2'}>Home page 02</Link></li>
                                <li><Link to={'/index-3'}>Home page 03</Link></li>
                                <li><Link to={'/index-4'}>Home page 04</Link></li>
                                <li><Link to={'/onepage'}>Onepage Version</Link></li>
                                <li><Link to={'/rtl-home'}>Home RTL</Link></li>
                                <li class="dropdown"><Link to={'/#'}>Header Styles</Link>
                                    <ul>
                                        <li><Link to={'/'}>Header Style One</Link></li>
                                        <li><Link to={'/index-2'}>Header Style Two</Link></li>
                                        <li><Link to={'/index-3'}>Header Style Three</Link></li>
                                        <li><Link to={'/index-4'}>Header Style Four</Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </li> */}
                        <li><Link to={'/home-english'}>Home</Link></li>
                        <li><Link to={'/about'}>About Us</Link></li>
                        {/* <li class="dropdown"><Link to={'/#'}>Services</Link>
                            <ul>
                                <li><Link to={'/services-1'}>Services One</Link></li>
                                <li><Link to={'/services-2'}>Services Two</Link></li>
                                <li><Link to={'/services-details'}>Services Details</Link></li>
                            </ul>
                        </li> */}
                        <li class="dropdown"><Link to={'/#'}>Projects</Link>
                        <ul>
                                                        <li><a href="https://massportall.firebaseapp.com/" target="_blank" rel="noreferrer">
                                                         MassPortal 
                                                        </a> 
                                                        </li>

                                                        <li><a href="https://mass-dev-cs.firebaseapp.com/" target="_blank" rel="noreferrer">
                                                        MassDev 
                                                        </a> 
                                                        </li>
                                                        <li><a href="https://math-ac2.web.app/" target="_blank" rel="noreferrer">
                                                        MATH Academy 
                                                        </a> 
                                                        </li>
                                                        
                                                        {/* <li><Link to={'/#'}>MassDev</Link></li>
                                                        <li><Link to={'/#'}>MATH Academy</Link></li> */}
                                                        <li><Link to={'/#'}>Terms</Link></li>
                                                    </ul>
                        </li>
                        {/* <li class="dropdown"><Link to={'/#'}>News</Link>
                            <ul>
                                <li><Link to={'/blog-grid'}>Blog Grid</Link></li>
                                <li><Link to={'/blog-standard'}>Blog Standard</Link></li>
                                <li><Link to={'/blog-details'}>Blog Details</Link></li>
                            </ul>
                        </li> */}
                        {/* <li><a href='#news-section'>Blogs</a></li> */}
                            {/* <ul>
                                <li><Link to={'/careers'}>Careers</Link></li>
                                <li><Link to={'/team'}>Team</Link></li>
                                <li><Link to={'/team-details'}>Team Details</Link></li>

                                <li class="dropdown"><Link to={'/#'}>Shop</Link>
                                    <ul>
                                        <li><Link to={'/shop'}>Products</Link></li>
                                        <li><Link to={'/product-details'}>Product Details</Link></li>
                                        <li><Link to={'/shopping-cart'}>Shopping Cart</Link></li>
                                        <li><Link to={'/checkout'}>Checkout</Link></li>
                                    </ul>
                                </li>
                                <li><Link to={'/faq'}>Faq's</Link></li>
                                <li><Link to={'/404'}>404</Link></li>
                            </ul> */}
                       

                        <li><Link to={'/contact'}>Contact</Link></li>
                        <li><Link to={'/rtl-home'}>عربي</Link> </li>
                    </ul>
                </div>

            </>
        )
    }
}
export default Menu;